import styled from "@emotion/styled";
import { Container } from "@mui/material";

export const LandingPageContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	minHeight: "100vh"
});

export const LandingPageSubContainer = styled(Container)(({ theme }) => ({
	flex: "1 1 auto",
	overflowX: "hidden",
	width: "100%",
	[theme.breakpoints.down("lg")]: {
		overflowX: "inherit"
	}
}));
